/**
 * @file mutations.js is a file for all SiteSettings mutations
 *
 * @author Steven Secreti
 */
import { gql } from "@apollo/client";

/**
 * @constant UPDATE_SITE_SETTINGS
 *
 * @summary GraphQL mutation that updates the singleton site settings document.
 */
export const UPDATE_SITE_SETTINGS = gql`
	mutation updateSiteSettings($input: UpdateSiteSettingsInput!) {
		updateSiteSettings(input: $input) {
			installLeadTime {
				enabled
				message
			}
		}
	}
`;
